<script lang="ts">
    import LastmileFilter from '../../shared/LastmileFilter.svelte';
    import { filter } from '../../../stores/filter';
    import { api, jobs_filter_config } from '../../../stores/api';
    import { CustomFilterManagerIO } from '../../utilities/FilterManagerIO';
    import { get } from 'svelte/store';
    import { jobs } from '../../../stores/store';

    export let filteredCount: number = 0;
    export let totalCount: number = 0;
    export let makeBlured: boolean = false;

    let filterManagerIO = new CustomFilterManagerIO(
        get(api),
        $filter.jobsToBeCompleted.managerStorageKey
    );

    let filterComponent: any = null;

    $: {
        if ($jobs.forceReloadFilter) {
            $jobs.forceReloadFilter = false;
            console.log('JobListFilter forceReload');
            filterManagerIO.load();
            filterManagerIO = filterManagerIO;
            if (filterComponent) {
                filterComponent.updateFilters($filter.jobsToBeCompleted.queries);
            }
        } else {
            console.log('JobListFilter no forceReload');
        }
    }
</script>

{#if $filter.jobsToBeCompleted}
    <LastmileFilter
        collectionName="jobs"
        onChange={queries => {
            $filter.jobsToBeCompleted.queries = queries;
        }}
        bind:this={filterComponent}
        showQuickFilters={false}
        filterConfig={$jobs_filter_config}
        enableInactiveQueries={true}
        filterManagerStorageKey={$filter.jobsToBeCompleted.managerStorageKey}
        {filteredCount}
        {totalCount}
        {makeBlured}
    />
{/if}
